import { api } from "./useApi";

export interface PagamentoBling {
    id: number;
    descricao: string;
    tipoPagamento: number;
    situacao: number;
    fixa: boolean;
    padrao: number;
    finalidade: number;
    juros: number;
    multa: number;
}

export interface ServicoLogisticaBling {
    id: number;
    descricao: string;
    codigo: string;
    aliases: string[];
    ativo: boolean;
}

export interface LogisticaBling {
    id: number;
    descricao: string;
    tipoIntegracao: string;
    servicos: ServicoLogisticaBling[];
}

export const blingApi = () => ({
    verificarAutenticacao: async () => {
        const response = await api.post("/bling/verificar_autenticacao");
        return response.data;
    },

    buscarDepositos: async () => {
        const response = await api.get("/bling/buscar_depositos");
        return response.data;
    },

    buscarPagamentos: async (): Promise<PagamentoBling[]> => {
        const response = await api.get("/bling/buscar_pagamentos");
        return response.data;
    },

    buscarLogisticas: async (): Promise<LogisticaBling[]> => {
        const response = await api.get("/bling/buscar_logisticas");
        return response.data;
    }
});
